angular
	.module 'App.Module.IntegrationLog', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'integration_logs',
				url: '/integration_logs',
				views:
					main:
						controller: 'IntegrationLogController'
						controllerAs: 'vm'
						templateUrl: '@app/integration-log/integration-log.view.html'
				data:
					hideSubMenu: true
					restrict: 'Backoffice.TopMenu.Setting.Integrations'

			.state 'integration_logs_gbat10',
				url: '/integration_logs/gbat10',
				views:
					main:
						controller: 'IntegrationLogController'
						controllerAs: 'vm'
						templateUrl: '@app/integration-log/integration-log-gbat10.view.html'
				data:
					hideSubMenu: true
					restrict: 'Backoffice.TopMenu.Setting.Integrations'
					fixedIntegrationId: 'accountingSftpGbat10'
